import { Fragment } from 'react'
import Typography from '@mui/material/Typography'
import Avatar from '../../avatar/Avatar'
import { Button, Chip, Paper } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import TextEllipsis from '../../text/TextEllipsis'

/**
 * CardChildren
 * @param {object}
 * @param icon  				
 * @param title 				
 * @param subtitle 
 */


const CardChildren = ({ photo, data, onClick, disabled = false, id, className, selected }) => {
  let items =  []
  if (data) {
    items =  Object.keys(data).map((key, i) => (
      <Fragment key={`child-${id}-${key}-${i}`}>
        <Typography color='primary' variant='inherit' className='uppercase text-right font-bold text-sm'>{key}</Typography>
        <Typography className='col-span-2 text-left initial-case text-nowrap overflow-hidden'>{data[key]}</Typography>
      </Fragment>
    ));
  }

  return (
    <Button
      component={Paper}
      variant='outlined'
      color={selected ? 'primary' : 'inherit'}
      id={id}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      className={`p-0 relative ${className ?? ''} ${selected ? 'selected' : ''}`}
      style={{ padding: 0 }}
    >
      { selected && <FontAwesomeIcon icon="circle-check" className='absolute -right-2 -top-2 text-2xl text-primary' /> }
      <div className='flex '>
        <Avatar 
          size="medium"
          alt={data.code}
          src={`photos/${photo}`} 
          variant="square" 
        />
        <div className='flex flex-col justify-center items-start gap-1 px-2'>
          <TextEllipsis variant='h6' fontWeight='bold' className='max-w-200px'>
            {data.student}
          </TextEllipsis>
          <Chip label={data.yearLevel} color="primary" size="small" />
          {/* {items} */}
        </div>
      </div>
    </Button>
  )
}

export default CardChildren